import ToastStore from "@components/common/toast/stores/ToastStore";
import AuthenticationStore from "@components/membership/stores/AuthenticationStore";
import AuthorizationStore from "@components/membership/stores/AuthorizationStore";
import CityStore from "@components/offer/stores/CityStore";
import RestaurantOfferStore from "@components/offer/stores/RestaurantOfferStore";
import UserOrderHub from "@components/order/hubs/UserOrderHub";
import OrderEditViewStore from "@components/order/stores/OrderEditViewStore";
import UserAddressEditViewStore from "@components/user-address/stores/UserAddressEditViewStore";
import RouterStore from "./RouterStore";
import RegistrationStore from "@components/membership/stores/RegistrationStore";

export default class RootStore {
    constructor() {
        this.toastStore = new ToastStore(this);

        this.userOrderHub = new UserOrderHub(this);

        this.cityStore = new CityStore(this);
        this.restaurantOfferStore = new RestaurantOfferStore(this);
        this.orderEditViewStore = new OrderEditViewStore(this);
        this.authenticationStore = new AuthenticationStore(this);
        this.authorizationStore = new AuthorizationStore(this);
        this.userAddressEditViewStore = new UserAddressEditViewStore(this);
        this.registrationStore = new RegistrationStore(this);
    }

    routerStore: RouterStore;
    toastStore: ToastStore;

    userOrderHub: UserOrderHub;

    cityStore: CityStore;
    restaurantOfferStore: RestaurantOfferStore;
    orderEditViewStore: OrderEditViewStore;
    authenticationStore: AuthenticationStore;
    authorizationStore: AuthorizationStore;
    userAddressEditViewStore: UserAddressEditViewStore;
    registrationStore: RegistrationStore;
}